import { el } from '../utils/dom.js';
import { Uploads } from '../api/resources.js';
import { err } from './toast.js';

/*
 * Subida de fotos. Sube los archivos al servidor en cuanto se seleccionan
 * y devuelve un array de URLs publicas via getUrls().
 */
export function PhotoUpload({ label = 'Fotos', max = 6 } = {}) {
  const urls = [];
  const previewWrap = el('div', { class: 'flex gap-2 wrap mt-2' });

  function renderPreviews() {
    previewWrap.replaceChildren(...urls.map((u, i) =>
      el('div', { style: 'position: relative; width: 72px; height: 72px;' },
        el('img', {
          src: u, alt: '',
          style: 'width: 100%; height: 100%; object-fit: cover; border-radius: var(--r-sm); border: 1px solid var(--border);',
        }),
        el('button', {
          type: 'button', class: 'btn ghost icon',
          style: 'position: absolute; top: -6px; right: -6px; padding: 0; width: 18px; height: 18px; background: var(--surface); border: 1px solid var(--border-strong); border-radius: 50%; font-size: 11px; line-height: 1;',
          onclick: () => { urls.splice(i, 1); renderPreviews(); },
        }, '×'),
      )
    ));
  }

  const input = el('input', {
    type: 'file', accept: 'image/*', multiple: true,
    style: 'display: none;',
    onchange: async (e) => {
      const files = Array.from(e.target.files || []).slice(0, max - urls.length);
      if (files.length === 0) return;
      btn.disabled = true; btn.textContent = 'Subiendo...';
      try {
        const r = await Uploads.images(files);
        for (const f of (r.files || [])) urls.push(f.url);
        renderPreviews();
      } catch (ex) { err(ex.message); }
      finally {
        btn.disabled = false; btn.textContent = '+ Subir fotos';
        input.value = '';
      }
    },
  });

  const btn = el('button', {
    type: 'button', class: 'btn',
    onclick: () => input.click(),
  }, '+ Subir fotos');

  const root = el('div', { class: 'field' },
    el('label', {}, label),
    el('div', { class: 'flex gap-2 items-center' }, btn, el('span', { class: 'text-xs muted' }, `Maximo ${max}`)),
    input,
    previewWrap,
  );

  return {
    root,
    getUrls: () => [...urls],
    clear: () => { urls.length = 0; renderPreviews(); },
  };
}
